<script lang="ts">
	import { validateUrl } from '../form/validations/validations'
	import Link from '../link/Link.svelte'
	import { price } from '../price/price'
	import ShortId from '../shortId/ShortId.svelte'
	import UserAgent from '../userAgent/UserAgent.svelte'
	import { ColumnType, type ValueType } from './types'
	import { _, numberPercentStyle } from '@repo/i18n'
	import { getHumanReadableDate, getHumanReadableDateTime } from '@repo/ui'
	import { IpAddress } from '@repo/ui'
	import { Action } from '@repo/ui'
	import { CountryFlag } from '@repo/ui'
	import { Icon } from '@repo/ui'
	import { ArrowDownTray, CheckCircle } from '@steeze-ui/heroicons'
	import { DateTime } from 'luxon'
	import { number } from 'svelte-i18n'
	import { run } from 'svelte/legacy'

	interface Props {
		value: ValueType | Promise<ValueType> | unknown
		columnType: ColumnType
		link?: string | null
	}

	let { value, columnType, link = null }: Props = $props()

	let val: ValueType = $state(null)
	run(() => {
		Promise.resolve(value).then((v) => (val = v as ValueType))
	})
</script>

{#if val || val === 0}
	{#if columnType === ColumnType.date}
		{#if val && typeof val === 'string'}
			{getHumanReadableDate(DateTime.fromISO(val))}
		{:else}
			{val.toLocaleString()}
		{/if}
	{:else if columnType === ColumnType.datetime}
		{#if val && typeof val === 'string'}
			{getHumanReadableDateTime(DateTime.fromISO(val))}
		{:else}
			&ndash;
		{/if}
	{:else if columnType === ColumnType.currency}
		{#if val}
			{#if typeof val === 'object'}
				{$price(Number(val.value), val.currencyCode)}
			{:else}
				{$price(Number(val))}
			{/if}
		{:else}
			&ndash;
		{/if}
	{:else if columnType === ColumnType.number}
		{#if val || val === 0}
			{$number(Number(val))}
		{:else}
			&ndash;
		{/if}
	{:else if columnType === ColumnType.rate}
		{#if val}
			{$number(Number(val), numberPercentStyle)}
		{:else}
			&ndash;
		{/if}
	{:else if columnType === ColumnType.download}
		{#if val}
			<div class="flex items-center justify-end">
				<a aria-label={$_('button.download')} href={String(val)} title={$_('button.download')}>
					<Action name="data-grid-item-download">
						<Icon src={ArrowDownTray} />
					</Action>
				</a>
			</div>
		{:else}
			&ndash;
		{/if}
	{:else if columnType === ColumnType.url}
		<code class="text-xs">{val}</code>
	{:else if columnType === ColumnType.userAgent}
		<UserAgent userAgent={val.toString()} />
	{:else if columnType === ColumnType.id}
		<ShortId id={val.toString()} {link} />
	{:else if columnType === ColumnType.ipAddress}
		<IpAddress ip={val.toString()} />
	{:else if columnType === ColumnType.country}
		<CountryFlag code={val.toString()} />
	{:else if columnType === ColumnType.boolean}
		<div class="flex items-center justify-center">
			<Icon class="text-green-500" src={CheckCircle} />
		</div>
	{:else if columnType === ColumnType.translate}
		{$_(val.toString())}
	{:else if val}
		{#if validateUrl(val.toString())}
			<Link name="link" href={val.toString()} target="_blank">
				{val}
			</Link>
		{:else}
			{val}
		{/if}
	{:else}
		&ndash;
	{/if}
{/if}
